import React, { useContext, useMemo } from "react";
import {
    Box,
    FormGroup,
    Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { AppContext } from "../../App";
import { selectChartConfig } from "../../selectors/chart";
import ColorSelector from "../colorSelector/colorSelector";
import tinycolor from "tinycolor2";
import CommonChartSettingsTabs from './commonChartSettingsTabs';
import { LineSeriesOptions } from "../chartV2/chart.typings";

type Props = {
    viewKey: string;
};

const StepLineSettings = ({ viewKey }: Props) => {
    const appContext = useContext(AppContext)
    const chart = appContext.getChart(viewKey)
    const chartConfig = useSelector(selectChartConfig(viewKey))
    const primarySeriesGroupId = useMemo(() => {
        return chart?.primarySeriesGroup?.config?.id
    }, [chart?.primarySeriesGroup?.config?.id])

    const color = useMemo(() => {
        let color = '#2962FF';
        if (primarySeriesGroupId) {
            const seriesId = chartConfig?.seriesGroups?.[primarySeriesGroupId]?.series?.[0]
            const series = chartConfig.series?.[seriesId ?? ''].options
            color = (series as any)?.color ?? '#2962FF'
        }
        return tinycolor(color)
    }, [chartConfig, primarySeriesGroupId])

    const handleColorChangeSeries = (newColor: string, type: keyof LineSeriesOptions) => {
        if (chart) {
            (chart.primarySeriesGroup?.getPrimarySeries() as any)?.updateOptions({
                [type]: newColor
            });
        }
    }

    const symbolTabContent = (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <FormGroup>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.1 }}>
                    <Typography variant="body2" sx={{ width: "160px" }}>Color</Typography>
                    <ColorSelector compact showOnlySwatch color={color.toHexString()} opacity={color.getAlpha()}
                        onColorChange={(c, transparency) => {
                            const newColor = tinycolor(c).setAlpha(transparency).toHex8String();
                            handleColorChangeSeries(newColor, 'color');
                        }} />
                </Box>
            </FormGroup>
        </Box>
    )

    return <CommonChartSettingsTabs viewKey={viewKey} symbolTabContent={symbolTabContent} />
}

export default StepLineSettings;
